<template>
  <div>
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive"></router-view>
    <layout-tabbar active-color="#DB1905" :tab-list="tabbarList"></layout-tabbar>
  </div>
</template>
<script>
import tabbar from '@/router/routes/tabbarRoute.js'
import layoutTabbar from '@/components/Tabbar.vue'
export default {
  components: {
    layoutTabbar
  },
  data () {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true
    };
  },
  computed: {
    tabbarList () {
      const list = tabbar[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: {
            active: item.icon.active,
            inactive: item.icon.inactive
          }
        }
      })
      return list
    }
  }
};
</script>
<style lang="scss" scoped>
</style>